var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForwardDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.96967 5.46967C9.26256 5.17678 9.73744 5.17678 10.0303 5.46967L16.0303 11.4697C16.3232 11.7626 16.3232 12.2374 16.0303 12.5303L10.0303 18.5303C9.73744 18.8232 9.26256 18.8232 8.96967 18.5303C8.67678 18.2374 8.67678 17.7626 8.96967 17.4697L14.4393 12L8.96967 6.53033C8.67678 6.23744 8.67678 5.76256 8.96967 5.46967Z",
    fill: "#63666A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardDisabled);
export default __webpack_public_path__ + "static/media/ForwardDisabled.3e5066d83919fa43e234c1f589878971.svg";
export { ForwardRef as ReactComponent };